'use strict';

var React = require('react'),
    Link = require('./Link'),
    PureRenderMixin = require('../mixins/PureRenderMixin'),
    { PropTypes } = React;

var ZineLink = React.createClass({
  mixins: [PureRenderMixin],

  propTypes: {
    zine: PropTypes.object.isRequired,
    bold: PropTypes.bool,
    showTitle: PropTypes.bool,
    withEllipsis: PropTypes.bool,
    className: PropTypes.string,
    target: PropTypes.oneOf(['_blank'])
  },

  getLinkTitle: function () {
    if (!this.props.showTitle) {
      return;
    }

    return this.props.zine.title;
  },

  render: function () {
    var title = this.getLinkTitle();

    return (
      <Link className={this.props.className}
            to={'zine'}
            params={{ zineSlug: this.props.zine.slug }}
            bold={this.props.bold}
            target={this.props.target}
            title={title}
            underline={this.props.underline}
            withEllipsis={this.props.withEllipsis}>
        {this.props.children || this.props.zine.title}
      </Link>
    );
  }
});

module.exports = ZineLink;



/** WEBPACK FOOTER **
 ** ./atoms/ZineLink.jsx
 **/